import CardService from '@/service/payment/serviceCard'
import { apicep } from '@/service/Api_cep/apicep'
import { ServiceStates } from '@/service/states/serviceStates'
import { ServiceCustomer } from '@/service/customer/serviceCustomer'

const serviceCustomer = new ServiceCustomer()
const cardService = new CardService()
const statesService = new ServiceStates()

export default {
  namespaced: true,

  state: {
    loading: false,
    cardForm: {
      holder_name: '',
      card_number: '',
      exp_month: '',
      exp_year: '',
      cvv: '',
      zip_code: '',
      address: '',
      address_number: '',
      complement: '',
      neighborhood: '',
      city: '',
      state: '',
      country: 'br',
    },
    mes_ano_card: '',
    useExistingAddress: true,
    cepInvalid: false,
    cepErrorMessage: '',
    cepLoading: false,
    optionsState: [],
    isSubmitting: false,
    address: {},
    cards: [],

    isEditingExistingAddress: false,
    editAddressForm: {
      zipCode: '',
      address: '',
      number: '',
      complement: '',
      district: '',
      city: '',
      state: '',
      cepInvalid: false,
      cepErrorMessage: '',
      cepLoading: false,
    },
  },

  getters: {
    getCardForm: state => state.cardForm,
    getExpiryDate: state => state.mes_ano_card,
    getUseExistingAddress: state => state.useExistingAddress,
    getCepStatus: state => ({
      invalid: state.cepInvalid,
      errorMessage: state.cepErrorMessage,
      loading: state.cepLoading,
    }),
    getStates: state => state.optionsState,
    getIsSubmitting: state => state.isSubmitting,
    gettersAddress(state) {
      return state.address
    },
    getIsEditingExistingAddress: state => state.isEditingExistingAddress,
    getEditAddressForm: state => state.editAddressForm,
  },

  mutations: {
    SET_CARD_FORM(state, payload) {
      state.cardForm = { ...state.cardForm, ...payload }
    },
    SET_EXPIRY_DATE(state, value) {
      state.mes_ano_card = value
    },
    SET_USE_EXISTING_ADDRESS(state, value) {
      state.useExistingAddress = value
    },
    SET_CEP_STATUS(state, { invalid, errorMessage, loading }) {
      if (invalid !== undefined) state.cepInvalid = invalid
      if (errorMessage !== undefined) state.cepErrorMessage = errorMessage
      if (loading !== undefined) state.cepLoading = loading
    },

    SET_STATES(state, states) {
      state.optionsState = states
    },
    SET_SUBMITTING(state, value) {
      state.isSubmitting = value
    },
    RESET_FORM(state) {
      state.cardForm = {
        holder_name: '',
        card_number: '',
        exp_month: '',
        exp_year: '',
        cvv: '',
        zip_code: '',
        address: '',
        address_number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        country: 'br',
      }
      state.mes_ano_card = ''
      state.cepInvalid = false
      state.cepErrorMessage = ''
      state.cepLoading = false
    },

    SET_ADDRESS(state, payload) {
      state.address = payload
    },

    SET_CARDS(state, payload) {
      state.cards = payload
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },

    SET_IS_EDITING_ADDRESS(state, value) {
      state.isEditingExistingAddress = value
    },

    SET_EDIT_ADDRESS_FORM(state, payload) {
      state.editAddressForm = { ...state.editAddressForm, ...payload }
    },

    RESET_EDIT_ADDRESS_FORM(state) {
      state.editAddressForm = {
        zipCode: '',
        address: '',
        number: '',
        complement: '',
        district: '',
        city: '',
        state: '',
        cepInvalid: false,
        cepErrorMessage: '',
        cepLoading: false,
      }
    },

    SET_EDIT_ADDRESS_CEP_STATUS(state, { invalid, errorMessage, loading }) {
      if (invalid !== undefined) state.editAddressForm.cepInvalid = invalid
      if (errorMessage !== undefined) state.editAddressForm.cepErrorMessage = errorMessage
      if (loading !== undefined) state.editAddressForm.cepLoading = loading
    },
  },

  actions: {
    async getCustomersByUUID({ commit }) {
      commit('SET_LOADING', true)
      const resultCustomer = await serviceCustomer.getCustomersByUuId()
      commit('SET_ADDRESS', resultCustomer.customer.address)
      commit('SET_CARDS', resultCustomer.customer.cards)
      commit('SET_LOADING', false)
    },

    async updateCustomer({ commit }, data) {
      commit('SET_LOADING', true)
      await serviceCustomer.updateCustomers(data)

      commit('SET_LOADING', false)
    },

    async fetchStates({ commit }) {
      try {
        const estados = await statesService.getStates() || []
        commit('SET_STATES', Array.isArray(estados) ? estados : [])
      } catch (error) {
        console.error('Erro ao carregar estados:', error)
        commit('SET_STATES', [])
      }
    },

    validateExpiryDate({ commit, state }) {
      const value = state.mes_ano_card.split('/').join('')
      const mes = value.substring(0, 2)
      const ano = value.substring(2, 4)
      const mesValido = parseInt(mes) <= 12 && parseInt(mes) > 0
      const currentYear = new Date().getFullYear().toString().substring(2, 4)
      const anoValido = parseInt(ano) >= parseInt(currentYear)

      if (mesValido && anoValido) {
        commit('SET_CARD_FORM', { exp_month: mes, exp_year: ano })
        return true
      }

      return false
    },

    setAddressFromExisting({ commit }, { address, useAddress }) {
      commit('SET_USE_EXISTING_ADDRESS', useAddress)

      if (useAddress && address) {
        commit('SET_CARD_FORM', {
          zip_code: address.zipCode || '',
          address: address.address || '',
          address_number: address.number || '',
          complement: address.complement || '',
          neighborhood: address.district || '',
          city: address.city || '',
          state: address.state || '',
        })
      } else if (!useAddress) {
        // Limpar campos de endereço se não usar o existente
        commit('SET_CARD_FORM', {
          zip_code: '',
          address: '',
          address_number: '',
          complement: '',
          neighborhood: '',
          city: '',
          state: '',
        })
      }
    },

    async addCard({ commit, state }) {
      commit('SET_SUBMITTING', true)
      try {
        // Formatar dados do cartão
        const cardData = { ...state.cardForm }
        cardData.card_number = cardData.card_number.replace(/\D/g, '')
        cardData.cvv = parseInt(cardData.cvv)

        // Adicionar o parâmetro useRegisteredCustomerAddress baseado no estado
        cardData.useRegisteredCustomerAddress = state.useExistingAddress || false

        // Se não estiver usando o endereço existente, incluir os dados de endereço
        if (!state.useExistingAddress) {
          cardData.zip_code = cardData.zip_code.replace(/\D/g, '')
          cardData.exp_month = parseInt(cardData.exp_month)
          cardData.exp_year = parseInt(cardData.exp_year)
        } else {
          // Se estiver usando endereço existente, remover campos de endereço do payload
          delete cardData.zip_code
          delete cardData.address
          delete cardData.address_number
          delete cardData.complement
          delete cardData.neighborhood
          delete cardData.city
          delete cardData.state
          delete cardData.country
        }

        const response = await cardService.addCardCustomer(cardData)
        commit('SET_SUBMITTING', false)

        if (response.status === 201) {
          commit('RESET_FORM')
          return { success: true, data: response.data }
        }

        return { success: false, error: 'Erro ao adicionar cartão' }
      } catch (error) {
        commit('SET_SUBMITTING', false)
        return {
          success: false,
          error: error.response?.data?.message || 'Erro ao adicionar cartão',
        }
      }
    },

    resetCardForm({ commit }) {
      commit('RESET_FORM')
    },

    toggleEditExistingAddress({ commit, state }) {
      const isEditing = !state.isEditingExistingAddress
      commit('SET_IS_EDITING_ADDRESS', isEditing)

      if (isEditing && state.address) {
        // Preenche o formulário de edição com os dados do endereço existente
        commit('SET_EDIT_ADDRESS_FORM', {
          zipCode: state.address.zipCode || '',
          address: state.address.address || '',
          number: state.address.number || '',
          complement: state.address.complement || '',
          district: state.address.district || '',
          city: state.address.city || '',
          state: state.address.state || '',
          cepInvalid: false,
          cepErrorMessage: '',
          cepLoading: false,
        })
      } else {
        commit('RESET_EDIT_ADDRESS_FORM')
      }
    },

    cancelEditAddress({ commit }) {
      commit('SET_IS_EDITING_ADDRESS', false)
      commit('RESET_EDIT_ADDRESS_FORM')
    },

    async searchAddressCep({ commit }, { cep, formType }) {
      const cepValue = cep.replace(/\D/g, '')

      if (cepValue.length !== 8) return

      commit('SET_EDIT_ADDRESS_CEP_STATUS', { loading: true })

      try {
        const response = await apicep(cepValue)

        if (response && response.cep) {
          if (formType === 'card') {
            commit('SET_CARD_FORM', {
              address: response.logradouro,
              neighborhood: response.bairro,
              city: response.localidade,
              state: response.uf,
              complement: response.complemento || '',
            })
            commit('SET_CEP_STATUS', { invalid: false, loading: false })
          } else if (formType === 'edit') {
            commit('SET_EDIT_ADDRESS_FORM', {
              address: response.logradouro,
              district: response.bairro,
              city: response.localidade,
              state: response.uf,
              complement: response.complemento || '',
            })
            commit('SET_EDIT_ADDRESS_CEP_STATUS', { invalid: false, loading: false })
          }
        } else {
          commit('SET_EDIT_ADDRESS_CEP_STATUS', {
            invalid: true,
            errorMessage: 'CEP inválido. Por favor, verifique e tente novamente.',
            loading: false,
          })
        }
      } catch (error) {
        if (formType === 'card') {
          commit('SET_CEP_STATUS', {
            invalid: true,
            errorMessage: 'CEP inválido. Por favor, verifique e tente novamente.',
            loading: false,
          })
        } else if (formType === 'edit') {
          commit('SET_EDIT_ADDRESS_CEP_STATUS', {
            invalid: true,
            errorMessage: 'CEP não encontrado. Por favor, adicione um CEP válido.',
            loading: false,
          })
        }
        console.error('Erro ao buscar CEP:', error)
      }
    },

    async saveEditAddress({ commit, state, dispatch }) {
      try {
        // Verificar se o endereço está completo
        const addressForm = state.editAddressForm
        const isComplete = addressForm.zipCode
            && addressForm.address
            && addressForm.number
            && addressForm.district
            && addressForm.city
            && addressForm.state

        if (!isComplete) {
          return {
            success: false,
            error: 'Por favor, preencha todos os campos obrigatórios do endereço.',
          }
        }

        // Preparar dados para atualização
        const formData = new FormData()
        formData.append('zipCode', addressForm.zipCode)
        formData.append('address', addressForm.address)
        formData.append('number', addressForm.number)
        formData.append('complement', addressForm.complement || '')
        formData.append('district', addressForm.district)
        formData.append('city', addressForm.city)
        formData.append('state', addressForm.state)

        // Atualizar o endereço
        commit('SET_LOADING', true)
        await serviceCustomer.updateCustomers(formData)

        // Atualizar o store com os novos dados
        commit('SET_ADDRESS', {
          zipCode: addressForm.zipCode,
          address: addressForm.address,
          number: addressForm.number,
          complement: addressForm.complement || '',
          district: addressForm.district,
          city: addressForm.city,
          state: addressForm.state,
        })

        // Recarregar dados do cliente
        await dispatch('getCustomersByUUID')

        commit('SET_IS_EDITING_ADDRESS', false)
        commit('RESET_EDIT_ADDRESS_FORM')
        commit('SET_LOADING', false)

        return { success: true }
      } catch (error) {
        commit('SET_LOADING', false)
        console.error('Erro ao atualizar endereço:', error)
        return {
          success: false,
          error: error.response?.data?.message || 'Erro ao atualizar endereço',
        }
      }
    },

    async deleteCardCredit({ commit, state }, cardId) {
      try {
        await cardService.deleteCardCustomer(cardId)
        commit('SET_CARDS', state.cards.filter(card => card.id !== cardId))
      } catch (error) {
        console.error('Erro ao excluir cartão de crédito:', error)
        throw error
      }
    },
  },
}
